import jsCookie from 'js-cookie';
import { useEffect, useState } from 'react';

export default function useCookiesAccepted() {
  const [cookiesAccepted, setCookiesAccepted] = useState(() => {
    if (typeof window === 'undefined') return false;

    return checkOptanonCookie();
  });

  useEffect(() => {
    if (cookiesAccepted) return;

    // Poll for cookie every 500ms for up to 10 seconds
    return pollForCookie(() => setCookiesAccepted(true));
  }, [cookiesAccepted]);

  return cookiesAccepted;
}

function checkOptanonCookie() {
  if (typeof window === 'undefined') return false;

  return Boolean(jsCookie.get('OptanonAlertBoxClosed'));
}

function pollForCookie(
  onCookieFound: () => void,
  options = { interval: 500, maxAttempts: 20 }
) {
  const { interval, maxAttempts } = options;
  let attempts = 0;

  const intervalId = setInterval(() => {
    attempts++;

    if (checkOptanonCookie()) {
      onCookieFound();
      clearInterval(intervalId);
    } else if (attempts >= maxAttempts) {
      clearInterval(intervalId);
    }
  }, interval);

  return () => clearInterval(intervalId);
}
